import React from "react";
import { AuthRightPanel } from "./AuthRightPanel";
import LoadingModal from "../../ui/Loader/LoadingModal";


const AuthLayout = ({
    LeftComponent,
    rightBgImage,
    isLoading = false,
    email,
    forgotPasswordOtp,
    logoImage
}) => {
    return (
        <>
            <section className="auth-section p-3 min-h-screen flex items-center justify-center bg-[#F5F5F5]">
                <div className="xl:max-w-full max-w-[1362px] w-full">
                    <div className="grid grid-cols-12 rounded-35 border border-purple-100 items-center overflow-auto cal-h shadow-shd-on mx-auto bg-white">
                        {LeftComponent &&
                            <LeftComponent
                                email={email}
                                forgotPasswordOtp={forgotPasswordOtp}
                                logoImage={logoImage}
                            />
                        } {/* entire left-side page component*/}
                        <AuthRightPanel bgImage={rightBgImage} /> {/* dynamic banner background */}
                    </div>
                </div>
            </section>
            {isLoading && <LoadingModal />}
        </>
    );
};

export default AuthLayout;
